import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box, Modal } from '@mui/material';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	background: '#FFFFFF 0% 0% no-repeat padding-box',
	boxShadow: '0px 3px 6px #00000029',
	borderRadius: '6px',
	padding: '40px',
};

const warningsMap = new Map([
	[ "nam_liv_person", 'Imię i nazwisko: ' ],
	[ "nam_fac_road", 'Adres: ' ],
	[ "nam_num_house", 'Nr domu: ' ],
	[ "nam_num_phone", 'Nr telefonu: ' ],
	[ "nam_oth_www", 'Adres www/email: ' ],
	[ "persName", 'Osoba: ' ],
	[ "placeName", 'Miejsce/adres: ' ],
	[ "geogName", 'Lokalizacja: ' ],
	[ "date", 'Numer (Tel./pesel/data): ' ],
]);

const SensitiveDataWarningItem = ({ data: { label, text } }) => (
	<p>{warningsMap.get(label)} <strong>{text}</strong></p>
);

const AddLetterSensitiveDataWarningModal = ({
	sensitiveDataWarning = null,
	sendDataRegardlessTheWarnings,
	closeSensitiveDataWarning,
}) => {
	//// IF editValues isn't null - switch do edit Mode
	const { dict } = useSelector((state) => state.app);

	const handleClose = useCallback(() => {
		closeSensitiveDataWarning();
	}, []);

	return (
		<Modal
			open={ !!sensitiveDataWarning }
			onClose={ handleClose }
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'
		>
			<Box
				sx={ style }
				className='narrow'
			>
				<div>
					<h2 className="modal-children__title">Dane osobowe</h2>
					<hr />
					<p><strong>Uwaga!</strong> Importowane pismo zawiera dane, które mogą być uznane za osobowe:</p>

					{sensitiveDataWarning && sensitiveDataWarning.map((item, index) => <SensitiveDataWarningItem
						key={ 'p' + index }
						data={ JSON.parse(item) }
					/>,
					)}

					<p style={ {marginTop: '10px'} }>Aby zapewnić bezpieczeństwo danych sprawdź pismo i upewnij się, że nie zawiera danych osobowych. Jeśli wskazane powyżej dane do takich nie należą - importuj mimo to.</p>
					<div className='addletter__modal__buttons'>
						<div
							className='button__std'
							onClick={ sendDataRegardlessTheWarnings }
						>
							Importuj mimo to
						</div>
						<div
							className='button__blue'
							onClick={ handleClose }
						>{dict.cancel}
						</div>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default React.memo(AddLetterSensitiveDataWarningModal);
